import { AxiosInstance } from 'axios'
import { BaseApi } from '@/api/BaseApi'
import { ICategoriesApiResponse, ICategoriesApiDetail } from '@/types/common/categories'

const PATH = {
  GET_CATEGORIES: '/api/common/categories',
} as const

export class CategoriesApi {
  baseApi: BaseApi
  constructor(axios: AxiosInstance) {
    this.baseApi = new BaseApi(axios)
  }

  /**
   * 撮影ジャンル情報取得
   */
  public async getCategories(): Promise<ICategoriesApiDetail[]> {
    const { data } = await this.baseApi.get<ICategoriesApiResponse>(PATH.GET_CATEGORIES)

    return data.categories.map((value) => ({
      id: value.id,
      slug: value.slug,
      name: value.name,
      mainImageUrl: value.main_image_url,
    }))
  }
}
